<template>
  <div class="chart-wrap"><canvas ref="cv"></canvas></div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, watch, nextTick } from 'vue'
import { Chart } from 'chart.js/auto'

export default {
  name: 'ChartCanvas',
  props: {
    type:    { type: String, default: 'bar' },     // bar | doughnut | line
    labels:  { type: Array,  default: () => [] },
    data:    { type: Array,  default: () => [] },
    colors:  { type: Array,  default: () => [] },
    label:   { type: String, default: '' },
    money:   { type: Boolean, default: false },
  },
  setup(props) {
    const cv = ref(null)
    let chart = null

    function cssVar(name, fallback) {
      const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim()
      return v || fallback
    }

    function render() {
      if (!cv.value) return
      if (chart) { chart.destroy(); chart = null }
      const accent = cssVar('--accent', '#76B900')
      const muted  = cssVar('--muted', '#6A7180')
      const grid   = cssVar('--border', '#ECEEF2')
      const palette = props.colors.length ? props.colors
        : [accent, cssVar('--high', '#B47514'), cssVar('--success', '#1E8A53'), '#5A8D00', '#B8432B']
      const isPie = props.type === 'doughnut' || props.type === 'pie'

      chart = new Chart(cv.value, {
        type: props.type,
        data: {
          labels: props.labels,
          datasets: [{
            label: props.label,
            data: props.data,
            backgroundColor: isPie ? props.labels.map((_, i) => palette[i % palette.length]) : accent,
            borderRadius: isPie ? 0 : 6,
            borderWidth: 0,
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { display: isPie, labels: { color: muted, font: { size: 11 } } } },
          scales: isPie ? {} : {
            x: { ticks: { color: muted, font: { size: 11 } }, grid: { display: false } },
            y: { beginAtZero: true, ticks: { color: muted, font: { size: 11 } }, grid: { color: grid } },
          },
        },
      })
    }

    onMounted(() => { nextTick(() => render()) })
    watch(() => [props.labels, props.data, props.type], () => { nextTick(() => render()) }, { deep: true })
    onBeforeUnmount(() => { if (chart) chart.destroy() })

    return { cv }
  },
}
</script>

<style scoped>
.chart-wrap { position: relative; height: 240px; }
</style>
